import React, { useState } from 'react';
import { Box, Typography, Divider, FormControl, List, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Remove';
import { useDropzone } from 'react-dropzone';
import { useStyles } from './styles.esm.js';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { InfoBox } from '../shared/InfoBox/InfoBox.esm.js';
import { convertToFile } from './utils.esm.js';
import UploadIcon from './assets/UploadIcon.esm.js';
export { UploadFilePickerSchema } from './schema.esm.js';

const UploadFilePicker = (props) => {
  const { onChange, formData, required, rawErrors, schema } = props;
  const [fileUploaded, setFileUploaded] = useState(formData ? [convertToFile(formData)] : []);
  const { uploadWrapper, uploadElement, textUploadElement, uploadedFileWrapper, thumb, removeThumb } = useStyles();
  const onDrop = async (acceptedFiles2) => {
    const file = acceptedFiles2[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result;
        onChange(base64Data);
      };
      reader.readAsDataURL(file);
      setFileUploaded([file]);
    }
  };
  const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/json": [".json"],
      "application/x-yaml": [".yaml", ".yml"]
    },
    maxSize: 1e6
  });
  const handleRemoveItem = (f) => {
    const updateFiles = acceptedFiles.filter((fileItem) => fileItem.name !== f.name);
    setFileUploaded(updateFiles);
    onChange(void 0);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { my: 1 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, schema.title ?? "Upload a File"), /* @__PURE__ */ React.createElement(Divider, null)), /* @__PURE__ */ React.createElement(Box, { my: 2 }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, schema.description ?? "Drag and drop or click anywhere below and add the file that will be used in the template.")), /* @__PURE__ */ React.createElement(
    FormControl,
    {
      className: uploadWrapper,
      margin: "normal",
      required,
      error: rawErrors?.length > 0
    },
    !formData ? /* @__PURE__ */ React.createElement("div", { ...getRootProps({ className: `${uploadElement} dropzone` }) }, /* @__PURE__ */ React.createElement("input", { ...getInputProps() }), /* @__PURE__ */ React.createElement(UploadIcon, null), /* @__PURE__ */ React.createElement("div", { className: textUploadElement }, isDragActive ? /* @__PURE__ */ React.createElement(Typography, { variant: "h6" }, "Drop the file here") : /* @__PURE__ */ React.createElement(Typography, { variant: "h6" }, "Drag and drop a file or ", /* @__PURE__ */ React.createElement("strong", null, "search")), /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle2" }, "The file must be YAML or JSON and up to ", /* @__PURE__ */ React.createElement("strong", null, "1MB in size")))) : /* @__PURE__ */ React.createElement("div", { className: uploadedFileWrapper }, /* @__PURE__ */ React.createElement(InfoBox, { message: "\u2705 Uploaded File" }), /* @__PURE__ */ React.createElement(List, { className: thumb }, fileUploaded.map((file) => /* @__PURE__ */ React.createElement(ListItem, { key: file.name }, /* @__PURE__ */ React.createElement(ListItemAvatar, null, /* @__PURE__ */ React.createElement(Avatar, null, /* @__PURE__ */ React.createElement(InsertDriveFileIcon, null))), /* @__PURE__ */ React.createElement(
      ListItemText,
      {
        primary: file.name,
        secondary: `${(file.size / 1024).toFixed(2)} KB`
      }
    ), /* @__PURE__ */ React.createElement(ListItemSecondaryAction, { className: removeThumb, onClick: () => handleRemoveItem(file) }, /* @__PURE__ */ React.createElement(RemoveIcon, null))))))
  ));
};

export { UploadFilePicker };
//# sourceMappingURL=UploadFIlePicker.esm.js.map
